import React, { useEffect, useRef, useState } from "react";
import { Header } from "../header";
import { Footer } from "../footer";
import axios from "axios";
import { Button, Input, message, Modal, Popover, Radio, Spin } from "antd";
import { ReactComponent as FilterIcon } from "../../../src/assets/images/filterIcon.svg";
import { CloseOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import "./products.css"
import greyImage from '../../assets/images/always-grey.png';
import Back2 from "../../../src/assets/images/back2.webp";
import { WhatsappIcon } from "../overlay/whatsapp";
import {baseUrl} from "../../../src/config"
export const Products = () => {
  const { Search } = Input;
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [visible,setVisible]=useState(false)
  const [categories,setCategories]=useState([])
  const [popoverVisible,setPopovereVisible]=useState(false)
    const headerRef:any=useRef();
      useEffect(()=>{
          headerRef?.current?.scrollIntoView({ behavior: 'smooth' });
      },[])
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    quantity: "",
    email: "",
    notes: "",
    category_id:"",
    product_id:""
  });
  const [expandedPreviews, setExpandedPreviews] = useState({});

  const handleTogglePreview = (productId) => {
    setExpandedPreviews((prev) => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  useEffect(() => {
    getCategories()
  }, []);

  const getProducts = async () => {
    console.log({ searchQuery });
    try {
      const resp = await axios.get(
        `${baseUrl}products?query=${searchQuery}&categoryId=${selectedCategory}`
      );
      console.log(resp.data); // Log the response to check
      const updatedProducts = resp.data.map((product) => ({
        ...product,
        selectedIndex:0,
        selectedImage: product?.images?.[0] || "", // Set initial selected image as the first one or empty string
      }));
      setProducts(updatedProducts);
    } catch (e) {
      console.error(e);
    }
  };

  const onSearch = () => {
    getProducts();
  };

  // Function to handle image selection for a specific product
  const handleImageSelect = (productId, image,idx) => {
    const updatedProducts = products.map((product) =>
      product.id === productId ? { ...product, selectedImage: image,selectedIndex:idx } : product
    );
    debugger
    setProducts(updatedProducts);
  };
  const handleCancel = () => {
    setVisible(false);
  };

 // Function to handle "Submit" button click
const handleSubmit = async () => {
  // Check if all fields in formData are filled
  const allFieldsFilled = Object.values(formData).every(value => {
    // Only trim if the value is a string
    return typeof value === 'string' ? value.trim() !== "" : value !== undefined && value !== null;
  });

  if (allFieldsFilled) {
    // If all fields are filled, log the form data and close the modal
    console.log("Form values:", formData);
    try {
      const resp = await axios.post(
        `${baseUrl}orders/add`, formData
      );
      console.log(resp.data); // Log the response to check
      if (resp?.data) {
        message.success("ordered successfully")
        setFormData({
          name: "",
          mobile: "",
          quantity: "",
          email: "",
          notes: "",
          category_id:"",
          product_id:""
        })
        setVisible(false);
      }
    } catch (e) {
      console.error(e);
    }

  } else {
    // If any field is empty, show a warning message
    message.error("Please fill in all fields before submitting.");
  }
};


  // Function to handle input changes
  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      [field]: value,
    });
  };


  const [selectedCategory, setSelectedCategory] = useState("");

  const handleRadioChange = (e) => {
    setSelectedCategory(e.target.value);
    setPopovereVisible(false)
  };

  // Generate a list of radio buttons dynamically (you can customize this list)

  const getCategories = async () => {
    try {
        const resp = await axios.get(
            `${baseUrl}categories`
        );
        console.log(resp.data); // Log the response to check
        setCategories(resp?.data);
    } catch (e) {
        console.error(e);
    }
};
  const content = (
    <div style={{ maxHeight: 200, overflowY: 'auto' }}>
        <CloseOutlined 
        style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} 
        onClick={() => setPopovereVisible(false)} 
      />
      <Radio.Group value={selectedCategory} onChange={handleRadioChange} style={{display:"flex",flexDirection:"column"}}>
        {categories?.map((c)=>{
          return  <Radio key={c?.id} value={c?.id }>
        {c?.name}
        </Radio>
        })}
      </Radio.Group>
      <Button style={{width:"100%",background:"#273975",color:"#000000"}} onClick={()=>{setSelectedCategory("");}}>Clear</Button>
    </div>
  );
  useEffect(()=>{
    getProducts()
  },[selectedCategory])
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "#ffffff",
        color: "#000000",
        backgroundImage: `url(${greyImage})`
      }}
      ref={headerRef}
    >
      <Header />
       <div style={{
            backgroundImage: `url(${Back2})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            fontSize: '40px',
            fontWeight: '500',
            color: 'white',
            padding: '60px 20px',
            width: '100%',
            textAlign: 'center',
          }}
        >
         PRODUCTS
        </div>
        <div style={{ borderBottom: "5px solid #e53535", width: "100%" }}></div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          gap: 30,
          width: "80%",
        }}
      >
        {/* <div style={{
            backgroundImage: `url(${Back2})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            color: 'white',
            padding: '60px 20px',
            width: '100%',
            textAlign: 'center',
          }}
        >
         PRODUCTS
        </div> */}
        {/* <div style={{ borderBottom: "1px solid #575555", width: "80%" }}></div> */}
        <div style={{ width: "80%", display: "flex", justifyContent: "space-between",alignItems:"center",gap:10,marginTop:"40px" }}>
          <div style={{ width: "96%" }}>
            <Search
              placeholder="Search here...."
              onSearch={onSearch}
              enterButton
              style={{ height: 60 }}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div>
          <Popover
          visible={popoverVisible}
        content={content}
        title="Select a category"
        trigger="click"
        onOpenChange={()=>setPopovereVisible(true)}
        placement="bottom"
      >
       <FilterIcon style={{cursor:"pointer"}} />
      </Popover>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            width: "90%",
            justifyContent: "center",
            marginBottom: 100,
            gap: 20,
          }}
        >
          {products?.length <1 &&   <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Spin size="large" tip="Loading..." style={{ color: '#273975' }} />
    </div>}
    {products?.length > 0 &&
        products.map((p) => {
          const isExpanded = expandedPreviews[p.id];
          const previewImages = isExpanded ? p.images : p.images?.slice(0, 4);

          return (
            <div className="products-card" key={p?.id}>
              <div
                title={p?.name}
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100%",
                  textAlign:"left"
                }}
              >
                {p?.name}
              </div>

              <div style={{ width: "100%" }}>
                <img
                 decoding="async"
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: 4
                  }}
                  src={
                    p?.selectedImage ||
                    (p?.images?.length > 0 ? p?.images[0] : "")
                  }
                  alt={p?.name}
                />
              </div>

              {/* Preview Images */}
              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                {previewImages?.map((i, index) => (
                  <img
                    loading="lazy"
                     decoding="async"
                    key={index}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      marginRight: 10,
                      marginBottom: 10,
                      border: index === p?.selectedIndex ? "2px solid #273975" : "none"
                    }}
                    src={i}
                    alt={`image-${index}`}
                    onClick={() => handleImageSelect(p.id, i, index)}
                  />
                ))}

                {/* Arrow to Expand */}
                {p?.images?.length > 4 && !isExpanded && (
                  <div
                    onClick={() => handleTogglePreview(p.id)}
                    style={{
                      cursor: "pointer",
                      fontSize: 28,
                      padding: "0 10px",
                      userSelect: "none"
                    }}
                  >
                    ➡
                  </div>
                )}

                {/* Optionally: "Show Less" button */}
                {p?.images?.length > 4 && isExpanded && (
                  <div
                    onClick={() => handleTogglePreview(p.id)}
                    style={{
                      cursor: "pointer",
                      fontSize: 14,
                      marginLeft: 10,
                      textDecoration: "underline",
                      color: "#273975"
                    }}
                  >
                    Show less
                  </div>
                )}
              </div>

              <div
                className="desc"
                style={{
                  fontSize: 14,
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  textAlign: "left",
                  width: "100%",
                  height: "100px",
                  overflow: "auto"
                }}
              >
                {p?.description}
              </div>

              <div style={{ width: "100%" }}>
                <Button
                  style={{
                    fontSize: 28,
                    fontWeight: 600,
                    background: "#273975",
                    color: "#000000",
                    padding: 20,
                    width: "100%",
                    marginTop: 20,
                    border:"none"
                  }}
                  onClick={() => {
                    setVisible(true);
                    setFormData({
                      ...formData,
                      category_id: p?.categoryId,
                      product_id: p?.id
                    });
                  }}
                >
                  ORDER NOW
                </Button>
              </div>
            </div>
          );
        })}
        
        </div>
      </div>
    
      
      <Modal
        title={<div style={{ textAlign: "center", fontSize: "24px", fontWeight: 600,background:"#D9D9D9" }}>Fill the form for order</div>} // Centering and increasing font size of the title
        visible={visible}
        onCancel={handleCancel}
        footer={null}  // Remove the default footer
        closable={false} // Hide the default close button (cross)
      >
        <div style={{ display: "flex", flexDirection: "column", background: "#D9D9D9" }}>
          {/* Field 1 */}
          <div style={{ marginBottom: 16, display: "flex", alignItems: "center" }}>
            <label style={{ marginRight: 8, width: "150px", fontSize: "16px", fontWeight: 600 }}>Name</label>
            <Input
              value={formData.name}
              onChange={(e) => handleInputChange(e, "name")}
              placeholder="Enter Name"
              style={{ flex: 1, fontSize: "16px", height: "40px", background: "#C2C2C2", color: "#000000" }} // Increased font-size and height
            />
          </div>

          {/* Field 2 */}
          <div style={{ marginBottom: 16, display: "flex", alignItems: "center" }}>
            <label style={{ marginRight: 8, width: "150px", fontSize: "16px", fontWeight: 600 }}>Mobile Number</label>
            <Input
              value={formData.mobile}
              onChange={(e) => handleInputChange(e, "mobile")}
              placeholder="Enter Mobile Number"
              style={{ flex: 1, fontSize: "16px", height: "40px", background: "#C2C2C2", color: "#000000" }} // Increased font-size and height
            />
          </div>

          {/* Field 3 */}
          <div style={{ marginBottom: 16, display: "flex", alignItems: "center" }}>
            <label style={{ marginRight: 8, width: "150px", fontSize: "16px", fontWeight: 600 }}>Email</label>
            <Input
              value={formData.email}
              onChange={(e) => handleInputChange(e, "email")}
              placeholder="Enter Email"
              style={{ flex: 1, fontSize: "16px", height: "40px", background: "#C2C2C2", color: "#000000" }} // Increased font-size and height
            />
          </div>

          {/* Field 4 */}
          <div style={{ marginBottom: 16, display: "flex", alignItems: "center" }}>
            <label style={{ marginRight: 8, width: "150px", fontSize: "16px", fontWeight: 600 }}>Quantity</label>
            <Input
              value={formData.quantity}
              onChange={(e) => handleInputChange(e, "quantity")}
              placeholder="Enter Quantity"
              style={{ flex: 1, fontSize: "16px", height: "40px", background: "#C2C2C2", color: "#000000" }} // Increased font-size and height
            />
          </div>

          {/* Field 5 */}
          <div style={{ marginBottom: 16, display: "flex", alignItems: "center" }}>
            <label style={{ marginRight: 8, width: "150px", fontSize: "16px", fontWeight: 600 }}>Notes</label>
            <TextArea
              value={formData.notes}
              onChange={(e) => handleInputChange(e, "notes")}
              placeholder="Enter Notes"
              style={{ flex: 1, fontSize: "16px", height: "40px", background: "#C2C2C2", color: "#000000" }} // Increased font-size and height
            />
          </div>

          {/* Buttons at the bottom with equal spacing */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
            <Button onClick={handleCancel} style={{ width: "48%", fontSize: "16px", height: "45px", background: "#C2C2C2", color: "#000000" }}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleSubmit} style={{ width: "48%", fontSize: "16px", height: "45px", background: "#273975", color: "#000000" }}>
              Order
            </Button>
          </div>
        </div>
      </Modal>
<WhatsappIcon/>
      <Footer />
    </div>
  );
};
